const siteConfiguration = {
  
  //API_URL: `http://localhost:65000/v1`,
  API_URL: "https://api-cabinet.kolding-markets.com/v1",
  CABINET_URL: "https://banca.kolding-markets.com",
  SITE_NAME: "Koldingmarkets",
  SITE_URL: "https://kolding-markets.com",
  SITE_LOGO: "/static/assets/images/logo.png",
  SITE_LOGOLOGIN: "/static/assets/images/logoLogin.png",
  FACEBOOK_URL: "https://www.facebook.com/koldingmarkets",
  TWITTER_URL: "https://www.twitter.com/koldingmarkets",
  BLOG_API_URL: "https://kolding-markets.com/blog/",
  METATRADER_URL: "https://banca.kolding-markets.com/static/content/mt4sw/sadasoftware4setup.exe",
  WEBTRADER_URL: "http://sm.tradetoolsfx.com/sbs/",
  COPYRIGHT: "Ⓒ Copyright 2022<br/> <a href='https://kolding-markets.com'>Koldingmarkets</a> All Rights Reserved.",
  COMPLIANCE_EMAIL: "compliance@kolding-markets.com",
  SHOW_WEBTRADER_LINK: false,
  DEPOSIT_AMOUNTS: [300, 500, 1000],
  DEFAULT_CURRENCY: "USD",
  TERMS_AND_CONDITIONS_URL: "https://kolding-markets.com/wp-content/uploads/2019/12/terms-and-conditions-1.pdf"
};

export default siteConfiguration;



// WEBPACK FOOTER //
// ./src/config/index.js